import { render, staticRenderFns } from "./goldenSentenceDilets.vue?vue&type=template&id=a0776eb4&scoped=true&"
import script from "./goldenSentenceDilets.vue?vue&type=script&lang=js&"
export * from "./goldenSentenceDilets.vue?vue&type=script&lang=js&"
import style0 from "./goldenSentenceDilets.vue?vue&type=style&index=0&id=a0776eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0776eb4",
  null
  
)

export default component.exports